import { useContext, useEffect, useState } from "react";
import { usePostHog } from 'posthog-js/react';

import { notifyError, notifySuccess } from "@utils/toast";
import { CartContext } from "@context/CartContext";
import * as gtag from "src/lib/gtag"

const useAddToCart = () => {
  const [item, setItem] = useState(1);
  const [products, setProducts] = useState([]);
  const posthog = usePostHog();

  const { addItem, items, updateItemQuantity } = useContext(CartContext);

  useEffect(() => {
    const prods = sessionStorage.getItem("allProducts");
    setProducts(JSON.parse(prods));
  }, []);




  const handleAddItem = (product, addOn) => {
    addOn.product = product._id;
    product.baseAddonPrice = addOn.addOnPrice;

    const newItem = {
      ...product,
      ...addOn,
      id: product._id,
      oldQty: product.quantity,
    };

    addItem(newItem, item, addOn);
    gtag.event({
      action: "add_to_cart",
      params: {
        items: [{
          item_id: product.sku,
          item_name: product.title
        }],
        value: product.price,
        currency: "BDT"
      }
    });

    // PostHog event
    posthog?.capture('Product Added', {
      product_id: product._id,
      sku: product.sku,
      name: product.title,
      category: product.parent,
      brand: product.brand || null,
      variant: addOn.variant || null,
      price: product.price,
      quantity: item,
      coupon: null, // Add coupon code if available
      position: null, // Add position in product list if available
      url: `/product/${product.slug}`,
      image_url: product.image || null,
      currency: "BDT",
      addon_price: addOn.addOnPrice,
      value: product.price * item
    });
  };

  const handleIncreaseQuantity = (item) => {
    const result = products?.find((p) => p._id === item.id);
    if (result) {
      if (item?.quantity < result?.quantity || item.ispreOrderAllowed) {
        updateItemQuantity(item.baseAddonPrice, item.id, item.quantity + 1);
      } else {
        notifyError("No more quantity available for this product!");
      }
    }
  };

  return {
    handleAddItem,
    setItem,
    item,
    handleIncreaseQuantity,
  };
};

export default useAddToCart;
